// src/menu.config.js
// Single source of truth for all sidebar menus (labels, hrefs, icons, role visibility).
// If you want to hide/show items by role later, add `roles: ['admin','superadmin']` on any entry.

import {
  // Sales Reports icons
  CheckCircleIcon,
  InfoOutlineIcon,
  PhoneIcon,
  WarningTwoIcon,
  AttachmentIcon,
  // Settings icons
  AtSignIcon,
  SettingsIcon,
  ViewIcon,
  EditIcon,
  CopyIcon,
  StarIcon,
} from '@chakra-ui/icons';

export const MENU = {
  base: [
    { label: 'Leads', href: '/leads' },
    { label: 'New Lead', href: '/leads/new' },
  ],

  salesReports: [
    {
      label: 'Sales',
      href: '/reports/sales',
      icon: CheckCircleIcon,
      roles: ['admin', 'superadmin'],
    },
    {
      label: 'Opportunities',
      href: '/reports/opportunities',
      icon: InfoOutlineIcon,
      roles: ['admin', 'superadmin'],
    },
    {
      label: 'Call Again',
      href: '/reports/callbacks',
      icon: PhoneIcon,
      roles: ['admin', 'superadmin'],
    },
    {
      label: 'Cancelled',
      href: '/reports/cancelled',
      icon: WarningTwoIcon,
      roles: ['admin', 'superadmin'],
    },
    {
      label: 'Archive',
      href: '/reports/archive',
      icon: AttachmentIcon,
      roles: ['admin', 'superadmin'],
    },
  ],

  settings: {
    label: 'Settings',
    children: [
      { label: 'Account', href: '/settings/account', icon: AtSignIcon },
      { label: 'Sales Reps', href: '/settings/sales-people', icon: InfoOutlineIcon },
      { label: 'Assign Roles', href: '/settings/assign-roles', icon: SettingsIcon },
      { label: 'Price List', href: '/settings/price-list', icon: ViewIcon },
      { label: 'Manage Doors', href: '/pricing/doors', icon: EditIcon },
      { label: 'Templates', href: '/settings/templates', icon: CopyIcon },
      { label: 'Branding', href: '/settings/branding', icon: StarIcon },
    ],
  },
};

// Helper: filter entries by role (future-proof; currently all admins can see everything)
export function allowByRole(items, role) {
  if (!items) return [];
  if (!role) return items; // while claims load, show (you can change this default later)
  return items.filter((it) => {
    if (!it.roles) return true;
    return it.roles.includes(role);
  });
}
